import { NgModule } from '@angular/core';
import { KnBrCustomSectionComponent } from './kn-br-custom-section.component';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';

@NgModule({
    imports: [
        CommonModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleAdminComponent: {
                    component: KnBrCustomSectionComponent,
                },
            },
        } as CmsConfig),
        KnBrCustomSectionComponent,
    ],
    exports: [KnBrCustomSectionComponent]
})

export class KnBrCustomSectionModule { }
